import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { getToken } from './api';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Clients from './pages/Clients';
import NewAdIdea from './pages/NewAdIdea';
import AdsStatus from './pages/AdsStatus';
import AdIdeaDetail from './pages/AdIdeaDetail';
import CreateImages from './pages/CreateImages';
import CreativeGallery from './pages/CreativeGallery';
import OpenAIUsage from './pages/OpenAIUsage';
import OpenAICostAnalysis from './pages/OpenAICostAnalysis';
import GreetingsCreative from './pages/GreetingsCreative';
import FontManager from './pages/FontManager';

function RequireAuth({ children }) {
  const token = getToken();
  if (!token) return <Navigate to="/login" replace />;
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<RequireAuth><Dashboard /></RequireAuth>} />
        <Route path="/clients" element={<RequireAuth><Clients /></RequireAuth>} />
        <Route path="/ads/new" element={<RequireAuth><NewAdIdea /></RequireAuth>} />
        <Route path="/ads/status" element={<RequireAuth><AdsStatus /></RequireAuth>} />
        <Route path="/ads/:id" element={<RequireAuth><AdIdeaDetail /></RequireAuth>} />
        <Route path="/ads/create-images" element={<RequireAuth><CreateImages /></RequireAuth>} />
        <Route
          path="/greetings/create"
          element={
            <RequireAuth>
              <GreetingsCreative />
            </RequireAuth>
          }
        />
        <Route path="/font-manager" element={<RequireAuth><FontManager /></RequireAuth>} />
        <Route path="/openai-usage" element={<RequireAuth><OpenAIUsage /></RequireAuth>} />
        <Route path="/openai-cost-analysis" element={<RequireAuth><OpenAICostAnalysis /></RequireAuth>} />
        <Route path="*" element={<Navigate to="/" replace />} />
<Route
  path="/ads/gallery"
  element={
    <RequireAuth>
      <CreativeGallery />
    </RequireAuth>
  }
/>
      </Routes>
    </BrowserRouter>
  );
}
